"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  -webkit-font-smoothing: antialiased;\n  font-size: 14px;\n  letter-spacing: 0.01rem;\n  line-height: 1;\n"], ["\n  color: ", ";\n  font-family: ", ";\n  font-weight: ", ";\n  -webkit-font-smoothing: antialiased;\n  font-size: 14px;\n  letter-spacing: 0.01rem;\n  line-height: 1;\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  margin-left: 0.4rem;\n  position: absolute;\n  bottom: 3.17rem;\n  text-decoration: none;\n  \n  &:hover {\n    text-decoration: none;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  margin-left: 0.4rem;\n  position: absolute;\n  bottom: 3.17rem;\n  text-decoration: none;\n  \n  &:hover {\n    text-decoration: none;\n  }\n"]),
    _templateObject3 = _taggedTemplateLiteral(["\n  width: 2.61rem;\n  margin-left: ", "rem;\n  margin-top: 0.5rem;\n"], ["\n  width: 2.61rem;\n  margin-left: ", "rem;\n  margin-top: 0.5rem;\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _buoyTheme = require("buoy-theme");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Text = _styledComponents2.default.div.withConfig({
  displayName: "PoweredBy__Text",
  componentId: "sc-72r698-0"
})(_templateObject, _buoyTheme.colors.white, _buoyTheme.fontFamily, _buoyTheme.fontWeight.regular);

var Container = _styledComponents2.default.a.withConfig({
  displayName: "PoweredBy__Container",
  componentId: "sc-72r698-1"
})(_templateObject2);

var LogoWrapper = _styledComponents2.default.div.withConfig({
  displayName: "PoweredBy__LogoWrapper",
  componentId: "sc-72r698-2"
})(_templateObject3, 4 / 18);

var BuoyLogo = function BuoyLogo() {
  return _react2.default.createElement(
    LogoWrapper,
    null,
    _react2.default.createElement(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 282.8 158.8" },
      _react2.default.createElement("path", {
        fill: "#fff",
        d: "M274.1 40.7h-.2c-4.9 0-8.9 4.6-8.9 10.1v24.4c-.1  9.9-8.1 17.9-18 17.9s-18-8.1-18-18V40.7h-18v25.1c-4.2-15.2-18.1-26.4-34.6-26.4s-30.5 11.2-34.6 26.4V41h-9.4c-4.7.3-8.5 4.7-8.5 10.1v24.4c-.1 9.9-8.1 17.9-18 17.9s-18-8.1-18-18L87.8 41H70v24.8c-4.2-15.2-18.1-26.3-34.6-26.3-6.6 0-12.7 1.8-18 4.9V10.2c0-5.6-4-10.1-8.9-10.1H-.4v75.4c0 19.8 16.1 35.9 35.9 35.9 17.5 0 32.1-12.5 35.2-29.1 3.2 16.6 17.7 29.1 35.2 29.1 17.5 0 32.1-12.6 35.3-29.2 3.1 16.6 17.7 29.2 35.3 29.2 17.6 0 32.2-12.6 35.3-29.3 3.2 16.5 17.8 29 35.2 29 6.6 0 12.7-1.8 18-4.9v17c-.1 9.2-6.8 18.4-24.1 18.4-2.3 0-4.5-.1-6.4-.4v9c.1 4.8 3.8 8.7 9.3 8.7h4.1c19.2-.5 34.6-16 35-35.2V40.9h-8.8zM35.4 93.5c-10 0-18.1-8.1-18.1-18.1v-.6h.1v-1.4c1-9 8.7-16.1 18-16.1 10 0 18.1 8.1 18.1 18.1.1 10-8.1 18.1-18.1 18.1zm141 0c-10 0-18.1-8.1-18.1-18.1 0-10 8.1-18.1 18.1-18.1 10 0 18.1 8.1 18.1 18.1.1 10-8.1 18.1-18.1 18.1z" })
    )
  );
};

var PoweredBy = function PoweredBy(props) {
  return _react2.default.createElement(
    Container,
    { href: props.url || "https://www.buoyhealth.com" },
    _react2.default.createElement(
      Text,
      null,
      "Powered by"
    ),
    _react2.default.createElement(BuoyLogo, null)
  );
};

exports.default = PoweredBy;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-sidebar-nav/dist/components/PoweredBy.js
// module id = 439
// module chunks = 168707334958949